module.exports = __webpack_public_path__ + "img/aligner.e887fb78.jpg";